import { InjectionToken } from '@angular/core';
import { GridType } from '@data-access/grid-views';

import { DEFAULT_BASE_GRID_PROPS } from '../constants';
import { OrganizationFacilitiesGrid } from '../types';

export const organizationFacilitiesInitialState: OrganizationFacilitiesGrid = {
  data: [],
  currentUrl: '',
  gridType: 'organizationFacilities' as GridType,
  views: [],
  ...DEFAULT_BASE_GRID_PROPS,
};

export const ORGANIZATION_FACILITIES_GRID_STATE =
  new InjectionToken<OrganizationFacilitiesGrid>(
    'Organization Facilities grid state',
    {
      factory: () => ({ ...organizationFacilitiesInitialState }),
    },
  );
